import NamedDto from 'modules/base/dto/NamedDto';

export class SensorValueDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.type = null;
		/** @type {number} */
		this.externalId = null;
	}

	/**
	 * @typedef {Object} _SensorValueDtoProps
	 * @property {string} type
	 * @property {number} externalId;
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _SensorValueDtoProps} SensorValueDtoProps
	 */
	/**
	 *
	 * @param {SensorValueDtoProps} props
	 * @returns {SensorValueDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		this.externalId = props.externalId;
		return this;
	}
}

export default SensorValueDto;
